import axios from 'axios';
import { UAParser } from 'ua-parser-js';

import { API_BASE_PATH } from './constants';

const LOG_CONTEXT_MAX_LENGTH = 32;
const LOG_EXCEPTION_TYPE_MAX_LENGTH = 200;
const LOG_MESSAGE_MAX_LENGTH = 2000;
const LOG_STACKTRACE_MAX_LENGTH = 20000;

export async function log(context: string, error: Error): Promise<void> {
  console.log({ context, error });

  try {
    const maxLengthContext = context.substring(0, LOG_CONTEXT_MAX_LENGTH);
    // The backend has no dedicated context field, so we prefix it onto the message.
    const message = `[${maxLengthContext}] ${error.message ?? ''}`.substring(0, LOG_MESSAGE_MAX_LENGTH);
    // error.stack can be undefined; fall back so the (required) field is never empty.
    const stackTrace = (error.stack || `${error.name}: ${error.message}`).substring(0, LOG_STACKTRACE_MAX_LENGTH);
    const exceptionType = error.name.substring(0, LOG_EXCEPTION_TYPE_MAX_LENGTH);
    const ua = new UAParser();
    const os = ua.getOS();

    // userid is derived server-side from the JWT, so it is not sent here.
    await axios.post(`${API_BASE_PATH}/log`, {
      exceptionType,
      message,
      stackTrace,
      appVersion: process.env.REACT_APP_VERSION,
      platform: os.name,
      osVersion: os.version,
      deviceModel: ua.getDevice().model,
      occurredAt: new Date().toISOString(),
    });
  } catch (err) {
    console.log({ err });
  }
}
